import {Okul} from '../../gql/StaticTypes'

interface OkulYonetimPageProps {
    okul: Okul
}

const OkulyonetimAdminPage = ({okul}: OkulYonetimPageProps) => {
    console.log(okul)

    return (
        <div className="db-admin-dashboard">
           selam {okul.isim}
        </div>
    )
}

export default OkulyonetimAdminPage
